<template>
  <div class="overlay" @click.self="$emit('close')">
    <div class="content dialog-center-margin">
      <div
        class="time-outer-box"
      >
        <div class="number-boxes" ref="number-box">
          <div class="number-box">
            <span v-if="digitOne === null" class="time-placeholder">0</span>
            <span v-else>{{ digitOne }}</span>
          </div>
          <div class="number-box">
            <span v-if="digitTwo === null" class="time-placeholder">0</span>
            <span v-else>{{ digitTwo }}</span>
          </div>
        </div>
        <div class="colon-box">:</div>
        <div class="number-boxes">
          <div class="number-box">
            <span v-if="digitThree === null" class="time-placeholder">0</span>
            <span v-else>{{ digitThree }}</span>
          </div>
          <div class="number-box">
            <span
              v-if="digitFour === null"
              class="time-placeholder faded-focused-number"
            >0</span>
            <span v-else class="focused-number">{{ digitFour }}</span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-center">
        <v-btn class="mr-4" color="grey" dark @click="$emit('close')">{{ $t('Cancel') }}</v-btn>
        <v-btn color="primary" @click="submit">{{ $t('Confirm') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeSelectionModal',
  props: {
    value: {
      type: String || null,
    },
  },
  data: () => ({
    timeValues: '',
    keypressListener: null,
  }),
  computed: {
    digitFour() {
      if (this.timeValues.length) {
        return this.timeValues.split('')[this.timeValues.length - 1];
      }
      return null;
    },
    digitThree() {
      if (this.timeValues.length > 1) {
        return this.timeValues.split('')[this.timeValues.length - 2];
      }
      return null;
    },
    digitTwo() {
      if (this.timeValues.length > 2) {
        return this.timeValues.split('')[this.timeValues.length - 3];
      }
      return null;
    },
    digitOne() {
      if (this.timeValues.length > 3) {
        return this.timeValues.split('')[this.timeValues.length - 4];
      }
      return null;
    },
    canSubmit() {
      return this.timeValues.length === 4;
    },
  },
  watch: {
    timeValues: {
      handler(newVal, oldVal) {
        let deletion = false;
        let result = newVal;

        if (newVal.length < oldVal.length) {
          deletion = true;
        }

        if (!deletion) {
          if (newVal.length === 1 && newVal > 2) {
            result = `0${newVal}`;
          }

          if (newVal.length === 2 && newVal > 23) {
            result = '23';
          }

          if (newVal.length === 3) {
            const digits = newVal.split('');
            if (digits[2] > 5) {
              result = `${digits[0]}${digits[1]}0${digits[2]}`;
            }
          }
        }

        this.timeValues = result;
      },
    },
  },
  mounted() {
    if (this.value) {
      const numbers = this.value.split('');
      this.timeValues = [numbers[0], numbers[1], numbers[3], numbers[4]].join('');
    }

    this.keypressListener = window.addEventListener('keydown', (e) => {
      const allowedChars = ['Digit0', 'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5',
        'Digit6', 'Digit7', 'Digit8', 'Digit9', 'Numpad0', 'Numpad1', 'Numpad2', 'Numpad3',
        'Numpad4', 'Numpad5', 'Numpad6', 'Numpad7', 'Numpad8', 'Numpad9', 'Backspace'];
      if (allowedChars.includes(e.code)) {
        if (e.code === 'Backspace') {
          this.timeValues = this.timeValues.slice(0, -1);
        } else {
          let digit;
          if (e.code.includes('Digit')) {
            digit = e.code.substring(5, 6);
          } else {
            digit = e.code.substring(6, 7);
          }

          if (this.timeValues.length < 4) {
            this.timeValues += digit;
          }
        }
      } else if (e.code === 'Enter') {
        this.submit();
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.keypressListener);
  },
  methods: {
    submit() {
      if (this.canSubmit) {
        const numbers = this.timeValues.split('');
        const formattedTime = [numbers[0], numbers[1], ':', numbers[2], numbers[3]].join('');
        this.$emit('submit', formattedTime);
        this.close();
      }
    },
    close() {
      this.timeValues = '';
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .overlay {
    background-color: rgba(0,0,0, 0.2);
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content {
    width: 400px;
    padding: 16px;
    background-color: #fff;
    border-radius: 8px;
  }

  .time-outer-box {
    height: 140px;
    width: 100%;
    background-color: #f9f9f9;
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: row;
    padding: 16px;
    border: 4px solid $primary;
  }

  .number-boxes {
    display: flex;
    flex: 1;
  }

  .number-box {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 70px;
    user-select: none;
  }

  .colon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    font-size: 50px;
    user-select: none;
  }

  .time-placeholder {
    color: #ddd;
  }

  .focused-number {
    color: $primary !important;
  }

  .faded-focused-number {
    color: #9db1ff !important;
  }
</style>
